module.exports = __webpack_public_path__ + "static/media/Icn-txt.baecc77e.svg";